import React from "react";
import aboutImg from "../assets/profilepic.png";
import Spline from "@splinetool/react-spline";

const About = () => {
  return (
    <div className="py-10 text-white max-w-[1400px] mx-auto" id="about">
      <div className="flex flex-col-reverse md:flex-row items-center md:items-stretch gap-6 px-6 lg:px-10 mx-auto min-h-[80vh]">
        {/* Left: Text Section */}
        <div className="w-full md:w-1/2 flex items-center">
          <div className="p-2">
            <div className="text-gray-300 my-3 max-w-[500px] mx-auto md:max-w-none">
              <h3 className="text-5xl font-semibold mb-5">
                About <span>Me</span>
              </h3>
              <p className="text-xl text-justify leading-7">
                Hi there! I'm Pradicksha, a final-year Software Engineering
                student at SLIIT. I'm currently working on my final year
                research project focused on an{" "}
                <b>
                  Intelligent Multimodal AI Platform for Autoimmune Disease
                  Screening
                </b>
                , exploring the potential of AI in medical diagnostics.
                <br />
                <br />
                Alongside my studies, I work at{" "}
                <b>
                  <a
                    href="https://arimac.digital/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline hover:text-blue-400"
                  >
                    Arimac Lanka
                  </a>
                </b>{" "}
                as an <b>Associate Software Engineer</b>, where I specialize
                in backend development using <b>Spring Boot</b>. My role
                involves building scalable APIs, integrating enterprise systems,
                and delivering production-grade solutions in a collaborative
                environment.
                <br />
                <br />
                Feel free to explore my portfolio to learn more about my
                projects, experiences, and aspirations. Let's connect and create
                impactful software together!
              </p>
            </div>
          </div>
        </div>

        {/* Right: Spline */}
        <div className="w-full md:w-1/2 flex items-center">
          <div className="w-full h-full">
            <Spline scene="https://prod.spline.design/f5FKjetXPRfx2PJA/scene.splinecode" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
